<template>
  <a-button
    class="cusButton"
    :type="type"
    :style="[{ borderColor: hoverd ? activeColor : '' }, { color: hoverd ? activeColor : '' }]"
  >
    <slot />
  </a-button>
</template>

<script setup>
import { ref, defineProps } from 'vue'
defineProps({
  type: {
    type: String,
    default: 'default'
  },
  hoverd: {
    type: Boolean,
    default: false
  }
})
const activeColor = ref('rgba(24, 144, 255, 1)')
</script>
<style lang="scss" scoped>
.cusButton {
  border-radius: 4px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
}
</style>
